import { getMessage } from 'lib/translator'

const PageConfig = [
  {
    pageUrl: '/offers/pin-wallet/add',
    name: getMessage('offer.pin.wallet'),
    getEndpoint: '/offer-service/monitored-offers/wallet-pinned-offers',
    postEndpoint: '/offer-service/monitored-offers/wallet-pinned-offers/add',
    transformResponse: (response) => response.data?.offers || [],
    transformPayload: (payload) => ({ offerIds: payload }),
  },
  {
    pageUrl: '/offers/mirakl_exclusions',
    name: getMessage('offer.mirakl.exclusions.text'),
    getEndpoint: '/offer-service/configurations/offer',
    postEndpoint: '/offer-service/configurations/offer',
    transformResponse: (response) => response?.data?.data || [],
    transformPayload: (payload) => ({ data: payload }),
  },
]

export default PageConfig
